"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'settings.status.active': 'Activo',
    'settings.status.inactive': 'Inactivo',
    'settings.status.enabled': 'Habilitado',
    'settings.status.disabled': 'Deshabilitado',
    'settings.status.connected': 'Conectado',
    'settings.status.notConnected': 'No Conectado',
    'settings.status.authenticated': 'Autenticado',
    'settings.status.notAuthenticated': 'No Autenticado',
};
